<template lang="pug">
v-container.mt-5.pb-8(:fluid="fluid")
  custom-title.pb-2.pb-md-8(align="center") {{ title }}
  slot
</template>

<script>
import CustomTitle from "@/components/shell/CustomTitle";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    get: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.get.forEach((v) => this.$rest(v).get());
  },
  components: {
    CustomTitle,
  },
};
</script>